import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto fit-content(100%)',
  gridTemplateRows: 'fit-content(100%)',
  backgroundColor: '#101828',
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(1),
  width: '100%',
};

export const leftColumn: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'start',
  justifySelf: 'stretch',
  gap: (p) => p.spacing(5),
  py: (p) => p.spacing(1.5),
  px: 0,
  borderRadius: (p) => p.spacing(1),
};

export const leftTitleSection: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: (p) => p.spacing(1),
  width: '100%',
};

export const videoWrapper: SxStyle = {
  width: (p) => p.spacing(44.125),
  height: (p) => p.spacing(53.75),
  maxWidth: '100%',
  borderRadius: (p) => p.spacing(1),
  position: 'relative',
  overflow: 'hidden',
  flexShrink: 0,
};

export const videoContent: SxStyle = {
  position: 'absolute',
  top: (p) => p.spacing(34.375),
  left: 0,
  width: (p) => p.spacing(44.125),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: (p) => p.spacing(1.5),
  py: (p) => p.spacing(3),
  px: 0,
  zIndex: 2,
};

export const videoTextWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  width: '100%',
};

export const verticalDivider: SxStyle = {
  width: '1px',
  backgroundColor: '#344054',
  alignSelf: 'stretch',
};

export const rightColumn: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  justifySelf: 'start',
  alignSelf: 'stretch',
  py: (p) => p.spacing(1.5),
  px: (p) => p.spacing(7),
  borderLeft: (p) => `1px solid ${p.palette.grey[700]}`,
};

export const rightTitleSection: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: (p) => p.spacing(77.5),
  maxWidth: '100%',
};

export const rightTitleInner: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: (p) => p.spacing(1),
  maxWidth: '100%',
};

export const rightSubtitle: SxStyle = {
  width: (p) => p.spacing(57),
  maxWidth: '100%',
  height: (p) => p.spacing(2.25),
};

export const creditsContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: (p) => p.spacing(1.5),
};

export const estimateHeader: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const categoriesGrid: SxStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, fit-content(100%))',
  gridTemplateRows: 'repeat(2, fit-content(100%))',
  gap: (p) => p.spacing(1.5),
  height: (p) => p.spacing(48.25),
  width: '100%',
};

export const categoryCard: SxStyle = {
  backgroundColor: '#1d2939',
  borderRadius: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(1.5),
  overflow: 'hidden',
  boxShadow:
    '0px 1px 3px 0px rgba(0,0,0,0.12), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.2)',
};

export const categoryHeader: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  pt: 0,
  pb: (p) => p.spacing(1),
  px: (p) => p.spacing(0.5),
  width: (p) => p.spacing(35),
};

export const categoryDivider: SxStyle = {
  backgroundColor: '#cfdbfc',
  opacity: 0.3,
  height: '1px',
  width: '100%',
};

export const creditRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.25),
  height: (p) => p.spacing(4.25),
  py: (p) => p.spacing(1),
  px: (p) => p.spacing(0.5),
  borderRadius: (p) => p.spacing(0.5),
  overflow: 'hidden',
  width: (p) => p.spacing(35),
};

export const creditRowLeft: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  flex: '1 0 0',
  minWidth: 0,
  minHeight: '1px',
  height: '100%',
};

export const creditRowRight: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  width: (p) => p.spacing(6.25),
  flexShrink: 0,
};

export const creditRowRightFree: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: (p) => p.spacing(6.25),
  flexShrink: 0,
};

export const modalBox: SxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  backgroundColor: 'background.paper',
  boxShadow: 24,
};
